<template>
	<page>
		<module>
			<view-list work-type="18" ref="view" :view-config="auth('b_stock_detail_viewmanage')">
				<template #search>
					<m-search ref="search" :init-data="initSearchData">
						<m-search-item label="仓库">
							<c-select name="warehouse_ids" async multiple @search="searchWarehouse"></c-select>
						</m-search-item>
						<m-search-item label="批次号" v-show="systemConfig.batch_stock == 1">
							<c-input name="batch_code"></c-input>
						</m-search-item>
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="产品规格">
							<c-input name="product_spec"></c-input>
						</m-search-item>
					</m-search>
				</template>
				<template #operate>
					<c-button v-if="auth('b_stock_detail_export')" v-lock="lock('b_stock_detail_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_stock_detail_export')" v-lock="lock('b_stock_detail_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>
				<!--【盘点】备注-->
				<template #remark="{data}">
					<span v-if="data.remark">{{data.remark}}</span>
					<span v-else>-</span>
				</template>
				<!--库存状态-->
				<template #stock_state="{data}">
					<c-state dict="stockStateName" :value="data.stock_state"></c-state>
				</template>
				<!--库存数量-->
				<template #product_count="{data}">
					<strong v-if="data.product_count && data.product_count > 0" style="color: green">{{data.product_count}}</strong>
					<strong v-else-if="data.product_count && data.product_count < 0" style="color: red">{{data.product_count}}</strong>
					<span v-else>{{data.product_count}}</span>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";
	export default {
		props: {
			in_batch_code: String
		},
		computed: {
		  // 获取dictName选项数据
		  ...mapState(['systemConfig']),
		},
		data() {
			return {
				initSearchData: {
					batch_code: this.in_batch_code||''
				}
			}
		},
		methods: {
			/*******搜索【仓库】下拉框信息*****************/
			searchWarehouse(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'WAREHOUSE',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>